import ContainerWrapper from "@components/BasicComponents/Wrappers/ContainerWrapper/ContainerWrapper"
import Separator from "@components/CustomTypography/Separator/Separator"
import ImageTextCard from "@components/WebsiteRevamp/ImageTextCard/ImageTextCard"
import Typography, {
	Variant,
} from "@components/WebsiteRevamp/Typography/Typography"
import {
	AdvancedSideAssetMainContent,
	AdvancedSideAssetModuleType,
} from "@hooks/WorkWithJson/GetComponentDataByKey/GetComponentDataByKeyTypes"
import React from "react"

import styles from "./HomeSecuritySection.module.scss"

type Props = {
	data: AdvancedSideAssetModuleType
}

const HomeSecuritySection = (props: Props) => {
	return (
		<section>
			<ContainerWrapper>
				<Separator size={128}>
					<Typography
						content={props.data.sectionTitle}
						variant={Variant.SectionTitle}
					/>
					<Separator />

					<div className={styles.cardContainer}>
						{props.data.mainContent?.map(
							(
								element: AdvancedSideAssetMainContent,
								index: number,
							) => {
								return (
									<ImageTextCard
										key={index}
										className={styles.cardBox}
										contentProps={{
											data: element,
											titleProps: {
												style: {
													marginBottom: "1.5rem",
													marginTop: "1.5rem",
												},
											},
											contentProps: {
												style: {
													marginBottom: "1.5rem",
												},
											},
										}}
										imageProps={{
											width: 150,
											height: 150,
											style: {
												width: "auto",
												height: "auto",
											},
										}}
									/>
								)
							},
						)}
					</div>
				</Separator>
			</ContainerWrapper>
		</section>
	)
}

export default HomeSecuritySection
